import React, { Component } from "react";
import Datas from "../../../data/course/popular.json";
import { Link } from "react-router-dom";
import { Styles } from "../styles/popularCourse.js";
import { Constant, imageDomain } from "../../../helper/Constants.js";
import axios from "axios";

class PopularExams extends Component {
  state = {
    courses: [], // will hold up to 5 courses
  };

  componentDidMount() {
    this.loadCourses();
  }

  buildImageUrl = (img, fallback = "/assets/images/default-course.jpg") => {
    if (!img) return process.env.PUBLIC_URL + fallback;
    if (/^https?:\/\//i.test(img)) return img;
    if (imageDomain) return imageDomain.replace(/\/$/, "") + (img.startsWith("/") ? "" : "/") + img;
    return (process.env.PUBLIC_URL || "") + (img.startsWith("/") ? img : "/" + img);
  };

  loadCourses = async () => {
    try {
      const url = (Constant.getUrls && Constant.getUrls.getAllExams) || "/api/courses";
      const resp = await axios.get(url);
      const payload = resp?.data?.data?.docs ?? resp?.data?.data ?? resp?.data ?? [];
      const list = Array.isArray(payload) ? payload : Array.isArray(payload.docs) ? payload.docs : [];
      if (list.length) {
        this.setState({ courses: list.slice(0, 5) });
        return;
      }
    } catch (err) {
      // silent fallback to local Datas below
      // console.error("PopularExams fetch failed:", err);
    }

    // fallback: use static Datas (take first 5)
    const fallbackList = Array.isArray(Datas) ? Datas.slice(0, 5) : [];
    this.setState({ courses: fallbackList });
  };

  renderCourseItem = (data, i) => {
    // support both API shape and local Datas shape
    const link = data.courseLink || (data.slug ? `/exam/${data.slug}` : `/exam-details/${data._id}`);
    const title = data.courseTitle || data.course_name || data.exam_name || "Untitled Course";
    const price = data.exam_venue !== undefined ? (typeof data.exam_venue === "number" ? `₹ ${data.exam_venue}` : data.exam_venue) : data.exam_venue || "Free";
    const img = data.imgUrl
      ? process.env.PUBLIC_URL + `/assets/images/${data.imgUrl}` // local Datas shape
      : data.image || data.banner || data.exam_poster || "";

    return (
      <div className="item-box d-flex" key={i}>
        <div className="item-img">
          <Link to={process.env.PUBLIC_URL + link}>
            <img src={this.buildImageUrl(img, "/assets/images/default-course.jpg")} alt={title} />
          </Link>
        </div>
        <div className="item-content">
          <p className="title">
            <Link to={process.env.PUBLIC_URL + link}>{title}</Link>
          </p>
          <ul className="list-unstyled list-inline rating">
            <li className="list-inline-item"><i className="las la-star"></i></li>
            <li className="list-inline-item"><i className="las la-star"></i></li>
            <li className="list-inline-item"><i className="las la-star"></i></li>
            <li className="list-inline-item"><i className="las la-star"></i></li>
            <li className="list-inline-item"><i className="las la-star"></i></li>
          </ul>
          {/* <p className="price">{price}</p> */}
        </div>
      </div>
    );
  };

  render() {
    const { courses } = this.state;

    return (
      <Styles>
        {/* Popular Course */}
        <div className="popular-course">
          <h5>Upcoming Exams</h5>
          <div className="popular-items">
            {courses && courses.length ? (
              courses.map((data, i) => this.renderCourseItem(data, i))
            ) : (
              <p>No upcoming exams found.</p>
            )}
          </div>
        </div>
      </Styles>
    );
  }
}

export default PopularExams;
